import { Accordion, AccordionSummary, AccordionDetails, Typography, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { faq } from "../utils/faq";

const FAQ: React.FC = () => {
    return (
        <Box
            sx={{
                maxWidth: 1200,
                mx: "auto",
                mt: { xs: 0, sm: 4 },
                p: { xs: 2, sm: 4 },
                overflow: "hidden",
                borderRadius: { xs: 0, sm: 5 },
            }}
        >
            <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
                Frequently Asked Questions
            </Typography>
            {faq.map((item, idx) => (
                <Accordion key={idx}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            {item.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">{item.answer}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
};

export default FAQ;
